import { TApplicationState } from '../../types/redux';

export const selectFormPhone = (state: TApplicationState) => state.requestFormV2.form.phone;
